import { render, staticRenderFns } from "./detailed-view.vue?vue&type=template&id=13505c93&"
import script from "./detailed-view.vue?vue&type=script&lang=js&"
export * from "./detailed-view.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/views/dashboard/members/id.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports